import axios from "../axiosPlugin.js";

const _PAYMENT_API = "/api/paymentType";

export const getPaymentListService = data => {
  return axios({
    url: `${_PAYMENT_API}/list`,
    method: "get",
    data: {
      data,
    },
  });
};

export const addPaymentService = data => {
  // return Promise.resolve({status:200})
  return axios({
    url: `${_PAYMENT_API}/create`,
    method: "post",
    data: {
      data,
    },
  });
};

export const updatePaymentService = data => {
  return axios({
    url: `${_PAYMENT_API}/update`,
    method: "post",
    data: {
      data,
    },
  });
};

export const PaymentServiceDetail = data => {
  return axios({
    url: `${_PAYMENT_API}/detail/${data.id}`,
    method: "get",
    data: {},
  });
};

export const delPaymentService = data => {
  return axios({
    url: `${_PAYMENT_API}/delete/${data.id}`,
    method: "get",
    data: {
      data,
    },
  });
};

export const getPaymentDetailService = data => {
  return axios({
    url: `${_PAYMENT_API}/detail/${data.id}`,
    method: "get",
    data: {
      data,
    },
  });
};

export const getPaymentNameListService = data => {
  return axios({
    url: `${_PAYMENT_API}/list/report`,
    method: "get",
    data: {
      data,
    },
  });
};

export const PaymentApproveService = data => {
  return axios({
    url: `${_PAYMENT_API}/approve?cinemaId=` + data.cinemaId,
    method: "post",
    data: {}
  });
};
